import { Layout } from 'antd';
import { useEffect, useState } from 'react';
import { getCustomers } from '../../redux/actions/customers';
import PrivateHeader from './Headers/Private';
import Menu from './Headers/Private/menu';
const { Sider, Content } = Layout;

const AppLayout = ({ children }) => {
    const [collapsed, setCollapsed] = useState(true);

    useEffect(() => {
        getCustomers();
    }, []);

    return (
        <Layout className="app-layout">
            <PrivateHeader />

            <Layout className="app-body">
                <Sider
                    className="app-sider"
                    width={200}
                    collapsible
                    collapsed={collapsed}
                    onCollapse={(value) => setCollapsed(value)}
                    theme="light"
                >
                    <Menu />
                </Sider>
                <Layout className="app-content-wrapper">
                    <Content className="app-content">{children}</Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

export default AppLayout;
